import axios from 'axios';
import { downloadFile, extractData, handleApiException, handleResponse } from 'helpers/apiResponseHelper';
import { CreateSaleOrderRequest, SaleOrder, SaleOrderCustomer, SaleOrderLoadingProvider, SaleOrderProduct } from 'models/sale-order';
import { apiService } from './api.service';

async function getOrders(customerId: number): Promise<SaleOrder[]> {
  return axios.get(apiService.getApiUrl() + '/sale-orders/' + customerId)
    .then(handleResponse).then(extractData).catch(handleApiException);
}

async function getCustomer(customerId: number): Promise<SaleOrderCustomer> {
  return axios.get(apiService.getApiUrl() + '/sale-orders/customer/' + customerId)
    .then(handleResponse).then(extractData).catch(handleApiException);
}

async function getLoadingProviders(): Promise<SaleOrderLoadingProvider[]> {
  return axios.get(apiService.getApiUrl() + '/sale-orders/loading-providers')
    .then(handleResponse).then(extractData).catch(handleApiException);
}

async function getProducts(loadingProviderId: number): Promise<SaleOrderProduct[]> {
  return axios.get(apiService.getApiUrl() + '/sale-orders/products?loadingProviderId=' + loadingProviderId)
    .then(handleResponse).then(extractData).catch(handleApiException);
}

async function createSaleOrder(customerId: number, request: CreateSaleOrderRequest, contactPersonId: number): Promise<any> {
    return axios.post(apiService.getApiUrl() + '/sale-orders/' + customerId, request, {
      params: {
        contactPersonId
      }
    }).then(handleResponse).then(extractData).catch(handleApiException);
}

async function acceptSaleOrder(customerId: number, documentUid: string, prepayment: boolean, contactPersonId: number): Promise<any> {
    return axios.post(apiService.getApiUrl() + '/sale-orders/' + customerId + '/accept/' + documentUid, null, {
      params: {
        contactPersonId,
        prepayment: prepayment ? 'true' : 'false'
      }
    }).then(handleResponse).catch(handleApiException);
}

async function cancelSaleOrder(customerId: number, documentUid: string, contactPersonId: number): Promise<any> {
    return axios.post(apiService.getApiUrl() + '/sale-orders/' + customerId + '/cancel/' + documentUid, null, {
      params: {
        contactPersonId
      }
    }).then(handleResponse).catch(handleApiException);
}


async function getSaleOrderFile(fileToken: string, name: string) {
    const url = apiService.getApiUrl() + '/sale-orders/pdf?fileName=' + fileToken
    return axios.get(url,
        {
            responseType: 'blob'
        }).then(handleResponse).then((res) => downloadFile(name + '.pdf', res, url)).catch(handleApiException);
}

const SaleOrderService = {
    getOrders,
    getCustomer,
    getLoadingProviders,
    getProducts,
    createSaleOrder,
    acceptSaleOrder,
    cancelSaleOrder,
    getSaleOrderFile
};

export default SaleOrderService;
